export default __webpack_public_path__ + "static/media/ico-aws-apigateway-circle-solid.a9ebbac1.svg";